import { FC, RefObject } from 'react'
import ImageUploading, { ImageListType, ImageType } from 'react-images-uploading'
import FbImageLibrary from '../FbImageLibrary'

import { TMediaCallbacks } from '../../pages/CreatePost'
import {
  TExtendedPostAttachment,
  TImportCanvaPayload,
  TRemoveAttachmentPayload
} from '../../store/managePost/newTypes'
import PostMediaPlaceholder, { MEDIA_TYPE_TO_UPLOAD } from '../PostMediaPlaceholder'

import { useDispatch } from '../../store/index'

import './UploadPostImages.scss'
import { importTemporaryMediaFromCanva } from '../../store/managePost/thunks'
import { TCanvaPayload } from '../PostCreation/CanvaButton/CanvaButton'

// TODO simplify and rename
interface UploadImageStep1Props {
  attachments: TExtendedPostAttachment[]
  isEditable: boolean
  addMediaToPost: (image: ImageType) => void
  removeMediaFromStore: (data: TRemoveAttachmentPayload) => void
  refMediaCallbaks: RefObject<TMediaCallbacks>
  firstImageHeight?: number
  restrictions: any
}

const UploadImage: FC<UploadImageStep1Props> = ({
  attachments,
  addMediaToPost,
  isEditable,
  refMediaCallbaks,
  restrictions,
  removeMediaFromStore,
  firstImageHeight,
  children
}) => {
  const dispatch = useDispatch()

  const onChange = (imageList: ImageListType) => {
    if (imageList.length) {
      imageList.forEach((image: ImageType) => addMediaToPost(image))
    }
  }

  const imageRestrictions = restrictions.mediaRestrictions.image

  const removeMedia = async (index: number) => {
    // TODO check all possible delete media cases
    const { id, temporaryId } = attachments[index]
    removeMediaFromStore({ id, temporaryId })
  }

  const updateCanvaImage = async ({
    exportUrl: content_url,
    designId: canva_design_id
  }: TCanvaPayload) => {
    const payload: TImportCanvaPayload = {
      content_url,
      canva_design_id
    }
    await dispatch(importTemporaryMediaFromCanva(payload))
  }

  return (
    <div className='upload-post-images'>
      <ImageUploading
        value={attachments}
        onChange={onChange}
        dataURLKey='data_url'
        acceptType={imageRestrictions?.valid_file_type}
        maxNumber={restrictions.message.max_mediafiles}
        multiple={true}
      >
        {({ imageList, onImageUpload, dragProps, errors }) => {
          if (refMediaCallbaks.current) refMediaCallbaks.current.addImage = onImageUpload

          return (
            <div className='upload-post-images__wrapper' {...dragProps}>
              {!imageList.length ? (
                <PostMediaPlaceholder
                  mediaType={MEDIA_TYPE_TO_UPLOAD.IMAGE}
                  onClick={onImageUpload}
                />
              ) : (
                <div className={`upload-post-images__images-wrapper`}>
                  <FbImageLibrary
                    hideOverlay={true}
                    firstImageHeight={firstImageHeight}
                    isEditable={isEditable}
                    images={attachments
                      .filter(({ object_data }) => !!object_data)
                      .map(({ object_data }) => object_data!)}
                    onRemove={removeMedia}
                    onUpdateCanvaImage={updateCanvaImage}
                  />
                </div>
              )}
              {errors && (
                <div className='upload-post-images__wrapper__error'>
                  {errors.maxNumber && (
                    <div className='upload-post-images__wrapper__error__item'>
                      Max images quantity for current post type is{' '}
                      {restrictions.message.max_mediafiles}
                    </div>
                  )}
                  {errors.acceptType && (
                    <div className='upload-post-images__wrapper__error__item'>
                      Allowed file types is {imageRestrictions?.valid_file_type.join(', ')}.
                    </div>
                  )}
                  {errors.maxFileSize && (
                    <div className='upload-post-images__wrapper__error__item'>File is too big</div>
                  )}
                  {errors.resolution && (
                    <div className='upload-post-images__wrapper__error__item'>
                      Selected file is not match your desired resolution
                    </div>
                  )}
                </div>
              )}
            </div>
          )
        }}
      </ImageUploading>
    </div>
  )
}

export default UploadImage
